module.exports = __webpack_public_path__ + "img/appliedJob.130aff79.svg";